import React from 'react';
import './index.scss';
import { getCategoryImage } from '../../utils/services';
import BURGER_IMAGE from './burger.jpeg';

const PreMealImage = ({
  imageUrls = null,
  alt = 'Burger',
  category = 'hpiv',
  className = ''
}) => {
  const image = getCategoryImage(imageUrls, category);

  const srcSet = image
    ? [
        image['1x'] && `${image['1x']} 1x`,
        image['2x'] && `${image['2x']} 2x`,
        image['3x'] && `${image['3x']} 3x`
      ]
        .filter(Boolean)
        .join(', ')
    : '';

  const src = image?.['1x'] || image?.['2x'] || image?.['3x'] || BURGER_IMAGE;

  return (
    <div className="meal-card__image-con">
      <img
        src={src}
        srcSet={srcSet || undefined}
        alt={alt}
        className={`meal-card__image ${className}`.trim()}
      />
    </div>
  );
};

export default PreMealImage;
